module.exports = __webpack_public_path__ + "static/media/20200907_H_Solution 3.01ce3525.svg";